module.exports = __webpack_public_path__ + "img/team-member-03.6a664378.jpg";